import RelatedVideoListItem from "./RelatedVideoListItem";
// import { useDispatch,  } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchReletedVideo } from "../../features/reletedVideo/reletedVideoSlice";
import Loding from "../ui/Loding";

export default function RelatedVideoList({ id, tags }) {
  //   console.log(id, tags);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchReletedVideo({ id, tags }));
  }, [id, dispatch, tags]);
  const state = useSelector((state) => state.reletedVideos);
  // console.log(state);

  const { isLoading, isError, error, reletedVideos } = state;
  let content = null;
  if (isLoading) {
    content = <Loding />;
  }
  if (!isLoading && isError) {
    content = error;
  }
  if (!isError && !isLoading && reletedVideos.length === 0) {
    content = <p>not Found!</p>;
  }
  if (!isError && !isLoading && reletedVideos.length > 0) {
    content = reletedVideos.map((video) => (
      <RelatedVideoListItem video={video} />
    ));
  }
  return (
    <div class="col-span-full lg:col-auto max-h-[570px] overflow-y-auto">
      {content}
    </div>
  );
}
